import React from 'react';
import client from 'services/apollo-client';
import TopRightMenu from 'components/canvas/components/top-right-menu';
import CanvasLoader from 'components/canvas/components/canvas-loader';
import { SurfaceNodeModal } from 'routes/surface/components/surface-node-modals/style';
import { useQuery } from '@apollo/client';
import { useHistory } from 'react-router';
import { Container } from './style';
import { homeSurfaceQuery } from 'graphql/surface/queries/home-surface';

function Home({ path }) {
  const history = useHistory();

  const modal = React.useRef<any>(null);

  const [isLoading, setLoading] = React.useState(false);

  const { data, loading, error } = useQuery<any>(homeSurfaceQuery, {
    client,
    fetchPolicy: 'network-only',
  });

  console.log('CORTLEX HOME ', data, loading, error);

  React.useEffect(() => {
    // Error will be handled in ErrorBoundary
    setLoading(true);
  }, [error]);

  const rootSurface = data?.homeSurface?.data;

  React.useEffect(() => {
    if (rootSurface?.id) {
      history.push(path + rootSurface.id);
    }
  }, [loading]);

  return (
    <>
      {(loading || isLoading) && <CanvasLoader />}
      <SurfaceNodeModal
        ref={modal}
        disableClose
        shouldCloseOnOverlayClick={false}
        onHide={() => {
          history.push(path + rootSurface.id);
        }}
      />
      <Container>
        <TopRightMenu />
      </Container>
    </>
  );
}

export default Home;
